module.exports = __webpack_public_path__ + "img/Gazena.b54ab8ff.png";